;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.RegistrationStep1 = Marionette.ItemView.extend({
		tagName: 'div',
		ui: {
			toNextStep: '#js-submit-step',
			toPrevStep: '#js-return-step',
			facebookConnect: '#facebook-connect',
			stateInput: '.state',
			sendRecoveryEmail: '#js-send-recovery-email'
		},

		events: {
			'click @ui.toNextStep': 'checkBeforeNextStep',
			'click @ui.toPrevStep': 'returnToPreviousStep',
			'click @ui.facebookConnect': 'facebookConnect',
			'click @ui.sendRecoveryEmail': 'sendRecoveryEmail'
		},
		initialize: function() {
			this.errors                  = false;
			this.backend_form_validation = [];
			this.view_data               = this.getOption('viewData');
			this.form_template           = this.getOption('formTemplate');
			this.steps_chain             = this.view_data.steps_chain;
			this.countries               = this.view_data.countries;
			this.states                  = this.view_data.states;
			this.squads                  = this.view_data.squads;
			this.fbconnect               = this.view_data.facebookModel;
			this.model                   = this.view_data.model;
			this.user                    = this.view_data.user;
			this.be_check                = this.view_data.first_step_BE_check;
			this.stepButtons             = this.view_data.first_step_buttons;
			this.dataLoaded              = false;
			var fields                   = this.view_data.first_step_fields;

			fields = fields.split(',');

			this.fields = fields;

			fields = _.map(fields , function(field){
				return field+':change ' + field+':blur';
			});

			this.getJSONData().showPreloader();

			this.form = new Backbone.Form({
				template: JST[this.form_template],
				model:    this.model,
				templateData: {
					first_step_fields:  this.fields,
					first_step_buttons: this.stepButtons
				}
			});

			this.initListeners(fields)
				.customInitAdder();

			$.when.apply(null, this.complete).done(_.bind(function() {

				this.form.data = {
					countryList: this.countries.toJSON(),
					statesList: this.states.toJSON(),
					squads: this.squads.toJSON()
				};

				this.dataLoaded = true;

				this.anchorToTop().hidePreloader();

				this.render();

			},this));

			return this.render();
		},

		initListeners: function(fields){

			this.listenTo(this.form, fields.join(' '), this.changeAndBlur);
			this.listenTo(this.form, 'country:change' , this.changeCountry);
			this.listenTo(this.user ,'backend:user:validation', function(resp){
				this.backend_form_validation.push(resp);
			});
			this.listenTo(this.fbconnect, 'facebook:error', function(error){
				this.showErrors([{text: error.text}])
			});

			this.listenTo(this.fbconnect, 'facebook:connect:success', this.preFillFormFromFbData);

			this.listenTo(this.fbconnect, 'facebook:status:connected', function(){
				this.fbconnect.getUserInfo();
			});

			return this;
		},

		getJSONData: function() {

			var collections = [this.squads, this.states, this.countries];

			this.complete    = _.invoke(collections, 'fetch', {cache: true, expires: 60 });

			return this;
		},

		render: function(){

			if(!this.dataLoaded)
				return;


			this.$el.html(this.form.render().el);

			this.changeCountry(this.form,_.first(this.form.fieldsets).fields.country);

			return this;
		},

		onShow:function(){
			this.fbAutoConnect();
		},

		fbAutoConnect: function(){

			if(this.fbconnect && this.fbconnect.get('auto_connect')){
				this.fbconnect.getLoginStatus();
			}

		},

		validate: function(){
			var errs = this.form.validate();
		},

		customInitAdder: function(){
			return this;
		},

		changeAndBlur: function(form, editor){
			if(!editor.getValue()){
				$(editor.el).removeClass('valid');
				$(editor.el).parents('.error').removeClass('error');
				$(editor.el).parent().next('div').html('');
				return;
			}
			var errs = this.form.fields[editor.key].validate();
			switch (editor.key){
				case 'email':
					this.form.fields.confirm_email.validate();
					break;
				case 'password':
					this.form.fields.passwordConfirm.validate();
					break;
				default:
					break;
			}
			!errs && editor.previousValue ? $(editor.el).addClass('valid') : $(editor.el).removeClass('valid');
			return this;
		},

		changeCountry: function(model, item){
			var toggleParents = (_.bind(function(model, item){
				var $state_input = $(this.ui.stateInput),
					$parents = $state_input.parents().eq(2),
					is_val = item && item.getValue() == 'AU',
					show_or_hide = is_val ? 'show' : 'hide',
					new_val = is_val ? 'ACT' : '';

				$parents[show_or_hide]();
				$state_input.val(new_val);
			}, this, model, item));

			setTimeout(toggleParents, 0);
		},

		checkBeforeNextStep: function(event){
			event.stopPropagation();
			this.showPreloader();
			this.errors = false;

			var err = this.form.validate();

			_.find(this.fields, _.bind(function(value){
				if(_.has(err, value)){
					this.scrollToFieldError(value);
					return this.errors = true;
				}
			},this));

			if (!this.errors)  {
				/*BACKEND VALIDATIONS*/
				this.backend_form_validation = [];
				var be_checkers = _.map(this.be_check, this.generateBEMethodsArr, this);

				this.onBackendCheckResponse(be_checkers);

			}
			else {
				this.hidePreloader();
			}
		},

		facebookConnect: function(){
			this.showPreloader();
			this.fbconnect.initFacebookConnect();
		},

		preFillFormFromFbData: function(){
			var user = this.fbconnect.get('user');
			this.form.setValue({
				first_name: user.firstname,
				last_name: user.lastname,
				email: user.email,
				confirm_email: user.conf_email
			});
			this.validate();
			this.hidePreloader();
			return this;
		},

		chooseNextStep: function(model) {
			model.step = this.steps_chain[_.indexOf(this.steps_chain, 'registrationStep1')+1] || 'completeRegistration';

			APP.vent.trigger('register:next:step', model);
			return this;
		},

		generateBEMethodsArr: function(method){
			return this.user[method](this.form);
		},

		returnToPreviousStep: function(){
			Backbone.history.history.back();
		},

		onBackendCheckResponse: function(ckeckers){

			$.when.apply(null, ckeckers)
				.done(_.bind(function() {

					if(!this.backend_form_validation.length){

						var
							pick_data = _.pick(this.form.getValue(), this.fields ),
							join_model_and_form = _.extend(this.model.toJSON(), pick_data),
							model = {
								form: this.model.set(join_model_and_form),
								fb: this.fbconnect
							};

						this.chooseNextStep(model);
					}
					else {

						this.showBackendErrors();

					}
				}, this));

			return this;
		},

		showBackendErrors: function(){
			var not_from_errors = [];

			_.each(this.backend_form_validation, _.bind(function(value){
				if(!value.param){
					not_from_errors.push(value);
				}
				if(value.param === 'email'){

					var
						elem = this.form.fields.email,
						errorData = this.getEmailErrorTextAndButton(value),
						login = _.template(
							'<div class="email-unique-login">' +
							'<div>' + errorData.text + '</div>' +
							'<div>' + errorData.button + '</div>' +
							'</div>'
						);

					$(elem.$el).addClass('error');
					$(elem.editor.el).removeClass('valid');
					$(elem.$el).find('.email-unique-login').remove();
					$(elem.$el).append(login);

					this.scrollToFieldError('email');
				}
				else {

					var
						elem = this.form.fields[value.param],
						message = _.template(
							'<div class="error_text"><div><%= value.text %></div></div>', value)
						;

					if(elem){
						$(elem.$el).addClass('error');
						$(elem.editor.el).removeClass('valid');
						$(elem.$el).find('div[data-error]').append(message({value:value}));
					}

					if(value.param){
						this.scrollToFieldError(value.param);
					}

				}
			}, this));

			if(not_from_errors.length){
				this.showErrors(not_from_errors);
			}

			return this.hidePreloader();
		},

		getEmailErrorTextAndButton: function(error){
			var response = {};
			switch (error.code){
				case 514:
					response.text = error.text;
					response.button = '<a href="#login" id="" class="btn base-button">Login &rsaquo;</a>';
					break;
				case 515:
					response.text = error.text;
					response.button = '<a href="#login" id="" class="btn base-button">Login and Activate &rsaquo;</a>';
					break;
				case 516:
					this.recoveryEmail = this.form.getValue('email');
					response.text = error.text;
					response.button = '<a href="javascript:void(0);" class="btn base-button" id="js-send-recovery-email">Set password  &rsaquo;</a>';
					break;
			}
			return response;
		},

		sendRecoveryEmail:function(){
			var email = {email: this.recoveryEmail};
			this.model.setApiUrl('password_recovery/send_token');
			this.showPreloader();
			this.model.save( null , { data: email, ajaxSync: true, success: _.bind(this.successPassRecovery, this)});
		},

		successPassRecovery: function(model, response){

			var elemObj = this.form.fields.email,
				elem = $(elemObj.$el);

			if(response.errors.length){
				this.showErrors(response.errors);
			}
			else {

				this.recoveryEmail = null;
				this.model.setApiUrl('');
				elem.removeClass('error');
				elem.find('.email-unique-login').remove();
				$(elemObj.editor.el).addClass('valid');

				Backbone.history.navigate('recovery-token-confirm', {trigger: true});

				this.hidePreloader();
			}

		},

		scrollToFieldError: function(val){

			if(this.form.fields[val]){
				$('html, body').animate({
					scrollTop: $(this.form.fields[val].el).offset().top
				}, 500);
			}

		},

		anchorToTop: function(){
			$('html, body').animate({
				scrollTop: 0
			}, 100);

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));